module.exports = __webpack_public_path__ + "img/bannerLogo.98a1526.png";